import VerofreshRecord from './VerofreshRecord'
import { get } from 'lodash'

class VehicleDataRecord extends VerofreshRecord {

  /**
   * Convenience method to grab a value from the telemetry
   * @param field
   * @returns {*}
   */
  getField (field) {
    return get(this.telemetry, field)
  }

  /**
   * Returns a comma separated string of latitude and longitude (e.g. 32.123445,-113.987654)
   *
   * @return string|undefined
   */
  getGpsCoordinatesAsString () {
    const lat = this.getField('lat')
    const long = this.getField('long')
    if (lat && long) {
      return `${lat.toFixed(6)},${long.toFixed(6)}`
    }
    return undefined
  }
}

export default VehicleDataRecord
